import { render } from "./RegistrationEditModal.vue?vue&type=template&id=5017695c&scoped=true&ts=true"
import script from "./RegistrationEditModal.vue?vue&type=script&lang=ts"
export * from "./RegistrationEditModal.vue?vue&type=script&lang=ts"

import "./RegistrationEditModal.vue?vue&type=style&index=0&id=5017695c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5017695c"]])

export default __exports__